import { functions } from '../../config/firebase';
import { httpsCallable } from 'firebase/functions';

export async function generateTextAudio(text) {
  const callable = httpsCallable(functions, 'generateTextAudio');
  const resp = await callable({ text });
  return (resp && resp.data) || {};
}
